module.exports = __webpack_public_path__ + "img/diamond.22fd6517.png";